// extracted by mini-css-extract-plugin
module.exports =  {"menuDepartmentLink":"header__IQkGB_paJRs8oNRsdpWA"};